/*!
 *
 *   2024 captcha
 *
 */

document.addEventListener("DOMContentLoaded", function () {
  var introContainer = document.getElementById("intro-container");
  var mainContainer = document.querySelector('main');

  var isIntroDisplayed = sessionStorage.getItem("isIntroDisplayed");
  if (!isIntroDisplayed) {
    introContainer.style.display="block";
    mainContainer.style.display='none';
  }else{
    introContainer.style.display="none";
    mainContainer.style.display='block';
  }


  introContainer.addEventListener("click", function () {
    sessionStorage.setItem("isIntroDisplayed", "true");
    $('#intro-container').fadeOut(500,
      //then fade in main
      function() {
        $('main').fadeIn(500);
      }
    );

  });

});
